import { render, staticRenderFns } from "./HeatmapRegistrationStep3.vue?vue&type=template&id=d2802f36&scoped=true"
import script from "./HeatmapRegistrationStep3.vue?vue&type=script&lang=js"
export * from "./HeatmapRegistrationStep3.vue?vue&type=script&lang=js"
import style0 from "./HeatmapRegistrationStep3.vue?vue&type=style&index=0&id=d2802f36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2802f36",
  null
  
)

export default component.exports